module.exports = __webpack_public_path__ + "static/media/CECP-JZ.b24223ee.png";